@if (isInitialLoad) {
<span class="ghost-line w-1/3"></span>
} @if (!isInitialLoad) { @if (claimStatus?.name) {
<cui-status-indicator
  class="my-bl-2"
  [status]="claimStatus?.name | claClaimStatus"
  [matTooltip]="toolTip"
  [attr.aria-label]="toolTip"
  [attr.tabindex]="tabIndex"
  [attr.aria-hidden]="false"
  role="status"
>
  {{ statusLabel }}
</cui-status-indicator>
} @if (!claimStatus?.name) { - } }
